import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { referrals } from "@/lib/api";
import { Gift, ShareNetwork, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ReferCard() {
  const [code, setCode] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { referrals.me().then(d => setCode(d.code)).catch(() => setCode(null)); }, []);
  if (!code) return null;
  const link = `${window.location.origin}/r/${code}`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "HaulGuard", text: "I use HaulGuard for pickup & delivery inspections and handoff records. Try it free:", url: link }); }
      catch { /* share sheet closed */ }
      return;
    }
    try { await navigator.clipboard.writeText(link); setCopied(true); toast.success("Referral link copied"); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Couldn't copy. Open Refer to copy your link."); }
  };

  return <section data-testid="refer-card" className="mb-8 flex flex-col sm:flex-row sm:items-center gap-4 bg-white border-2 border-accent p-4">
    <Gift size={34} weight="duotone" className="text-accent shrink-0"/>
    <div className="flex-1 min-w-0">
      <div className="font-display font-bold text-lg leading-tight">Refer a hauler, earn a free month</div>
      <div className="text-sm text-muted-foreground">When they start a paid plan, your next renewal moves back a month. <Link to="/app/referrals" data-testid="refer-card-details" className="underline font-bold text-foreground">See your referrals</Link></div>
    </div>
    <button onClick={share} data-testid="btn-refer-card-share" className="btn-amber shrink-0">
      {copied ? <Check size={18} weight="bold"/> : <ShareNetwork size={18} weight="bold"/>} {copied ? "Link copied" : "Share"}
    </button>
  </section>;
}
